import { get, post } from "../../service/api";
export const CreateNegdiOrderPayment = async (data) => {
    try {
        const response = await post(`/negdi/order/payment`,data);
        if(response && response.data)
             return response.data;
        else return null
    } catch (error) {
        console.error('Error CreateNegdiOrderPayment:', error);
        return null;
    }
};
